const serveBindList = () => import('@/views/main/marketing/serve/list/list.vue')
export default {
  path: '/main/coupon/serveBind',
  name: 'serveBindList',
  component: serveBindList,
  children: []
}
